// import all svg flags from public/images/flags
import caSVG from "../../../assets/flags/ca.svg";
import dkSVG from "../../../assets/flags/dk.svg";
import euSVG from "../../../assets/flags/eu.svg";
import hkSVG from "../../../assets/flags/hk.svg";
import jySVG from "../../../assets/flags/jy.svg";
import nzSVG from "../../../assets/flags/nz.svg";
import seSVG from "../../../assets/flags/se.svg";
import chSVG from "../../../assets/flags/ch.svg";
import usSVG from "../../../assets/flags/us.svg";
import auSVG from "../../../assets/flags/au.svg";
import gbSVG from "../../../assets/flags/gb.svg";
// import cbSVG from "../../../assets/flags/cb.svg";
import ilSVG from "../../../assets/flags/il.svg";
import muSVG from "../../../assets/flags/mu.svg";
import sgSVG from "../../../assets/flags/sg.svg";
// import dkSVG from "/public/images/flags/dk.svg";
// import euSVG from "/public/images/flags/eu.svg";
// import hkSVG from "/public/images/flags/hk.svg";
// // import jySVG from "/public/images/flags/jy.svg";
// import nzSVG from "/public/images/flags/nz.svg";
// import seSVG from "/public/images/flags/se.svg";
// import chSVG from "/public/images/flags/ch.svg";
// import usSVG from "/public/images/flags/us.svg";
// import auSVG from "/public/images/flags/au.svg";
// import gbSVG from "/public/images/flags/gb.svg";
// // import cbSVG from "/public/images/flags/cb.svg";
// import ilSVG from "/public/images/flags/il.svg";
// import muSVG from "/public/images/flags/mu.svg";
// import sgSVG from "/public/images/flags/sg.svg";

export const getFlag = (flag) => {
  switch (flag) {
    case "CA":
      return caSVG;
    case "DK":
      return dkSVG;
    case "EU":
      return euSVG;
    case "HK":
      return hkSVG;
    case "JY":
      return jySVG;
    case "NZ":
      return nzSVG;
    case "SE":
      return seSVG;
    case "CH":
      return chSVG;
    case "US":
      return usSVG;
    case "AU":
      return auSVG;
    case "GB":
      return gbSVG;
    // case "CB":
    //   return cbSVG;
    case "IL":
      return ilSVG;
    case "MU":
      return muSVG;
    case "SG":
      return sgSVG;
    // default:
    //   return caSVG;
  }
};
